import React from "react";
import PropTypes from "prop-types";
import "./LayoutSimple.scss";

import LanguageSelector from "../LanguageSelector";
import SignInThemeSwitcher from "../SignInThemeSwitcher";
import Text from "../Text";

import version from "../../../version";

const LayoutSimple = (props) => {
  return (
      <div className={`layout-simple ${props.styleName}`}>
      {props.children}
      <div className="footer">
        <div className="version footer-left">{`version: ${version}`}</div>
        <div className="logo footer-right">
          <a id="contact-button" className="contact-button" href="/#/contact">
            <Text value="CONTACT" />
          </a>
          <a href="http://www.innsoft.pl">
            <img src="resources/images/innsoft_INNS.svg" alt="" />
          </a>
        </div>
        <LanguageSelector className="footer-right" />
        <SignInThemeSwitcher />
      </div>
    </div>
  );
};

LayoutSimple.propTypes = {
  version: PropTypes.string,
};

LayoutSimple.defaultProps = {
  version: "version",
};

export default LayoutSimple;
